import { Chakra } from '../Chakra'

export default function App({ Component, pageProps }) {
  return (
    <Chakra cookies={pageProps.cookies}>
      <Component {...pageProps} />
      <link rel="icon" href="/favicon.ico" sizes="any" />
    </Chakra>
  )
}